import React from 'react';
import { X, FileText } from 'lucide-react';
import styles from './NotesViewerModal.module.css';

const NotesViewerModal = ({ notes, isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2>
            <FileText className={styles.headerIcon} />
            Заметки инженера
          </h2>
          <button className={styles.closeButton} onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.photoList}>
            {notes.length > 0 ? (
              <div className={styles.notesGrid}>
                {notes.map((note, index) => (
                  <div key={note.id} className={styles.photoItem}>
                    <div
                      className={styles.noteContent}
                      dangerouslySetInnerHTML={{ __html: note.content || '' }}
                    />
                    <div className={styles.photoDetails}>
                      <p>
                        <strong>Создано</strong>
                        {formatDate(note.created_at)}
                      </p>
                      <p>
                        <strong>Обновлено</strong>
                        {formatDate(note.updated_at)}
                      </p>
                      <p>
                        <strong>Автор</strong>
                        {note.created_by || 'Неизвестно'}
                      </p>
                      <p>
                        <strong>Изменил</strong>
                        {note.updated_by || 'Неизвестно'}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.noPhotos}>
                <FileText size={48} style={{ opacity: 0.3, marginBottom: '16px' }} />
                <p>Заметки отсутствуют</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesViewerModal;
